
import { Component, Inject, Vue } from "vue-property-decorator";
import {
  ISegmentResultsProviderData,
  ISegmentResultsProviderMethods
} from "@/models/providers/segments";
import { ISegmentTypes } from "@/data/enums/segments";

@Component
export default class SegmentResultsConfig extends Vue {
  // Inject
  @Inject({ from: "segmentResultsProvider" })
  public segmentResultsProvider!: () => ISegmentResultsProviderData;

  @Inject({ from: "segmentResultsProviderMethods" })
  public $segmentResultsProviderMethods!: ISegmentResultsProviderMethods;

  public proxy: any = null;

  public get $segmentResultsData() {
    return this.segmentResultsProvider();
  }

  public get config() {
    return { i18n: this.i18n };
  }

  public get i18n() {
    switch (this.$segmentResultsData?.segmentType) {
      case ISegmentTypes.CLIENT:
        return {
          quickSearchPlaceholder: this.$t(
            "_placeholder.client_quick_search"
          ).toString()
        };
      case ISegmentTypes.ORDER:
        return {
          quickSearchPlaceholder: this.$t(
            "_placeholder.orders_quick_search"
          ).toString()
        };
      case ISegmentTypes.CONTRACTS_PRODUCTS:
      case ISegmentTypes.CONTRACTS_PRODUCTS_SUBSCRIPTION:
      case ISegmentTypes.CONTRACTS_PRODUCTS_SALE:
        return {
          quickSearchPlaceholder: this.$t(
            "_placeholder.product_quick_search"
          ).toString()
        };
      default:
        return {};
    }
  }

  // Life-cycle methods
  public render() {
    return (
      this.$scopedSlots?.default &&
      this.$scopedSlots.default({
        config: this.config,
        $segmentResultsData: this.$segmentResultsData,
        $segmentResultsMethods: this.$segmentResultsProviderMethods
      })
    );
  }
}
